import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import * as Config from '../../app/app.config';
import {AuthProvider} from '../auth/auth';

import {Storage} from '@ionic/storage';
import {Platform} from 'ionic-angular';

/*
  Generated class for the QuizzServerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class QuizzServerProvider {

  private quizzId: number = null;
  private questionId: number = null;
  // private medias: MediaItem[];
  // private mediasSuccess: any[];
  private canContractQuizz: boolean = false;

  constructor(
    private http: Http,
    private auth: AuthProvider,
    // private proofProvider: ProofProvider,
    private storage: Storage,
    private platform: Platform,
    // private mediaProvider: MediaProvider,
    // private file: File,
    // private fileProvider: FileProvider
  ) {
    console.log('Hello QuizzServerProvider Provider');
  }

  getQuizzId(): number {
    return this.quizzId;
  }

  setQuizzId(quizzId: number) {
    this.quizzId = quizzId;
  }

  getQuestionId(): number {
    return this.questionId;
  }

  setQuestionId(questionId: number) {
    this.questionId = questionId;
  }

  public getCanContractQuizz() {
    return this.canContractQuizz;
  }

  public setCanContractQuizz(canContractQuizz: boolean) {
    this.canContractQuizz = canContractQuizz;
  }

  /**
   * Get status of quizz.
   */
  public getStatus() {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/quizz/status', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Establish a contract of quizz.
   *
   * @param id
   */
  public contract(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/quizz/contract/' + id, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Returns all subscriptions of quizz.
   */
  public fetchAll() {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/quizz', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
          // console.log('fetchAll ----->', data);
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Fetch quizz details.
   *
   * @param $id
   */
  public fetch(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/quizz/detail/' + id, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Retrieve URL of graph of performance.
   *
   * @param id
   */
  public fetchPerfomanceGraphUrl(id: number) {
    return Config.baseUrl + '/quizz/performance/' + id + '/graph/?token=' + this.auth.getToken();
  }

  /**
   * Retrieve next question of quizz.
   */
  public fetchNextQuestion() {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/quizz/nextquestion/', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Retrieve URL of media of next question.
   */
  public fetchNextQuestionMediaUrl() {
    return Config.baseUrl + '/quizz/nextquestion/media/?token=' + this.auth.getToken();
  }

  /**
   * Answer the question.
   *
   * @param id
   * @param formData
   */
  public answerQuestion(id: number, formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/quizz/question/' + id, formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Add a selfie to question.
   *
   * @param id
   * @param formData
   */
  public selfieForQuestion(id: number, formData: any) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.post(Config.baseUrl + '/quizz/question/' + id + '/selfie', formData, {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Finish the question.
   *
   * @param id
   */
  public finishQuestion(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/quizz/question/' + id + '/finish', {headers: headers})
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/quizz-server/quizz-server.ts